module.exports = __webpack_public_path__ + "img/kefu.d55e8e78.png";